import { useId } from "react";

/**
 * Free-text search input. Controlled by the parent (the `useSearch` hook owns
 * the query string). Shows a clear affordance once text is present.
 */
interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchBar({
  value,
  onChange,
  placeholder = "Search the archive…",
}: SearchBarProps) {
  const id = useId();
  return (
    <div className="searchbar">
      <span className="searchbar__icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
          <path
            d="M21 21l-4.3-4.3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <label htmlFor={id} className="sr-only" style={{ position: "absolute", left: "-9999px" }}>
        Search
      </label>
      <input
        id={id}
        type="search"
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button
          type="button"
          className="searchbar__clear"
          aria-label="Clear search"
          onClick={() => onChange("")}
        >
          ✕
        </button>
      )}
    </div>
  );
}
